import raterJs from 'rater-js';
import ApplicationController from './application_controller';

export default class extends ApplicationController {
  connect() {
    this.initializeRating();
  }

  initializeRating() {
    const averageRating = parseFloat(this.element.dataset.averageRating);

    raterJs({
      element: this.element,
      max: 5,
      rating: averageRating,
      readOnly: true,
      starSize: 16,
      step: 0.5,
      ratedFill: '#f5a623',
      unfilledColor: '#ccc',
    });
  }
}
